const state = {
    currentNotice: null,
};

const mutations = {
    updateNotice(nextState, currentNotice) {
        nextState.currentNotice = currentNotice;
    },
};

const actions = {
    setCurrentNotice: (context, notice) => context.commit('updateNotice', notice),
    removeCurrentNotice: (context) => context.commit('updateNotice', null),
};

export default {
    state,
    actions,
    mutations,
};
